export default __webpack_public_path__ + "static/media/arlington_flyer.2630760e.jpg";